import { FormEvent, useRef, useState } from "react"
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';

import './Slider.scss';
import 'swiper/css';

import SwiperCore from 'swiper';

export default function Slider({ urlImages }: { urlImages: string[] }) {

    const [isFullScreen, setIsFullScreen] = useState(false);
    const [initialSlide, setInitialSlide] = useState(0);
    const [canOpen, setCanOpen] = useState(false);

    const mainSwiperRef = useRef<SwiperCore | null>(null);

    const openFullScreen = (slideIndex: number) => {
        setInitialSlide(slideIndex);
        setIsFullScreen(true);
    };

    const closeFullScreen = () => {
        setIsFullScreen(false);
    };

    return (
        <div className="locationMeet_slider-wrapper">
          <Swiper
            slidesPerView={3}           
            centeredSlides={true}       
            slideToClickedSlide={true} 
            spaceBetween={-125}  
            grabCursor={true}       
           
            initialSlide={1}
            speed={500}
            onSwiper={(swiper: SwiperType) => (mainSwiperRef.current = swiper)}
            
            breakpoints={{
                1440: {
                slidesPerView: 3,
                },
                1140: {
                slidesPerView: 3,
                },
                900: {
                slidesPerView: 3,     
                },
                700: {
                slidesPerView: 3,           
                },
                585: {
                slidesPerView: 3,
                },
                0: {
                slidesPerView: 3,
                spaceBetween: -100,
                },
            }}
          >
            {urlImages.map((slide, index) => (    
              <SwiperSlide 
                key={slide}
                onPointerDown={(e) => {

                    if (e.currentTarget.classList.contains('swiper-slide-active')) {
                      setCanOpen(true);
                    } else {
                      setCanOpen(false);
                    }
                }}

                onClick={() => {
                    if (canOpen) {
                      openFullScreen(index);
                    }
                  }}
              >
                <img 
                    src={slide} 
                    alt={`slider_photo_${index + 1}`} 
                    className="slider-image"
                    
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Полноэкранный режим */}

          {isFullScreen && (
            <div className="fullscreen-overlay"
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    closeFullScreen();
                }
            }}
            >
                <button className="close-btn" onClick={closeFullScreen}>
                    &#x2715;
                </button>
                <Swiper            
                initialSlide={initialSlide}   
                slidesPerView={1}
                centeredSlides={true}
                spaceBetween={50}
                modules={[Navigation]}
                navigation={true}
                keyboard={{ enabled: true }}
                speed={600}
                >
                  {urlImages.map((slide, index) => (
                    <SwiperSlide key={`fullscreen-slide-${index}`}>
                      <img src={slide} alt={`slider_photo_${index + 1}`} />
                    </SwiperSlide>
                ))}
                </Swiper>
          </div>
          )}
        </div>
      );
  }; 
